import React, { useContext } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import LocalStorage from 'utils/myLocalStorage'
import ComponentsUNames from 'constants/componentsUNames'
import { SideNav, SideNavItem, SideNavSection, useColorMode } from '@airbus/components-react/components'
import i18n from 'i18n'
import LightDarkContext from 'context/LightDarkModeContext'

const { t } = i18n

export const getPermission = (path: string) => {
  switch (path) {
    case '/amasis-web/fleetpan':
      return (
        eval('CONFIGAPP__LICACCESS["' + ComponentsUNames.TABFLOT_LICACCESS + '"]') &&
        LocalStorage.getOrDefault(
          [LocalStorage.KEY_PERMISSIONS, ComponentsUNames.TABFLOT_PERMISSIONS],
          LocalStorage.VALUE_TYPE.BOOLEAN,
          false,
        )
      )
    case '/amasis-web/techlog':
      return (
        eval('CONFIGAPP__LICACCESS["' + ComponentsUNames.CRM_LICACCESS + '"]') &&
        LocalStorage.getOrDefault(
          [LocalStorage.KEY_PERMISSIONS, ComponentsUNames.CRM_DISPLAY_PERMISSIONS],
          LocalStorage.VALUE_TYPE.BOOLEAN,
          false,
        )
      )
    case '/amasis-web/workpackage':
      return (
        eval('CONFIGAPP__LICACCESS["' + ComponentsUNames.BDV_LICACCESS + '"]') &&
        LocalStorage.getOrDefault(
          [LocalStorage.KEY_PERMISSIONS, ComponentsUNames.BDV_PERMISSIONS],
          LocalStorage.VALUE_TYPE.BOOLEAN,
          false,
        )
      )
    case '/amasis-web/orders':
      return (
        eval('CONFIGAPP__LICACCESS["' + ComponentsUNames.ORDERS_LICACCESS + '"]') &&
        (LocalStorage.getOrDefault(
          [LocalStorage.KEY_PERMISSIONS, ComponentsUNames.ORDERS_STCA_PERMISSIONS],
          LocalStorage.VALUE_TYPE.BOOLEAN,
          false,
        ) ||
          LocalStorage.getOrDefault(
            [LocalStorage.KEY_PERMISSIONS, ComponentsUNames.ORDERS_STCA_AOG_PERMISSIONS],
            LocalStorage.VALUE_TYPE.BOOLEAN,
            false,
          ) ||
          LocalStorage.getOrDefault(
            [LocalStorage.KEY_PERMISSIONS, ComponentsUNames.ORDERS_STCL_PERMISSIONS],
            LocalStorage.VALUE_TYPE.BOOLEAN,
            false,
          ) ||
          LocalStorage.getOrDefault(
            [LocalStorage.KEY_PERMISSIONS, ComponentsUNames.ORDERS_STCR_PERMISSIONS],
            LocalStorage.VALUE_TYPE.BOOLEAN,
            false,
          ) ||
          LocalStorage.getOrDefault(
            [LocalStorage.KEY_PERMISSIONS, ComponentsUNames.ORDERS_STCS_PERMISSIONS],
            LocalStorage.VALUE_TYPE.BOOLEAN,
            false,
          ))
      )
    case '/amasis-web/stocks':
      return (
        eval('CONFIGAPP__LICACCESS["' + ComponentsUNames.STOCKS_LICACCESS + '"]') &&
        LocalStorage.getOrDefault(
          [LocalStorage.KEY_PERMISSIONS, ComponentsUNames.STOCKS_DSP_PERMISSIONS],
          LocalStorage.VALUE_TYPE.BOOLEAN,
          false,
        )
      )
  }
}

export function getFirstTwoSegments(pathname: string) {
  const segments = pathname.split('/').filter(Boolean)

  const firstTwo = segments.slice(0, 2)
  return '/' + firstTwo.join('/')
}

export const getMenuItems = () => [
  { path: '/amasis-web/fleetpan', label: t('9500050'), display: getPermission('/amasis-web/fleetpan') },
  { path: '/amasis-web/techlogs', label: t('7001825'), display: getPermission('/amasis-web/techlog') },
  { path: '/amasis-web/workpackage', label: t('9500092'), display: getPermission('/amasis-web/workpackage') },
  { path: '/amasis-web/orders', label: t('9420008'), display: getPermission('/amasis-web/orders') },
  { path: '/amasis-web/stocks', label: t('9510083'), display: getPermission('/amasis-web/stocks') },
]

const NavBar = ({ onToggleMenu, isOpened }: { onToggleMenu: () => void; isOpened: boolean }) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { mode } = useContext(LightDarkContext)

  return (
    <SideNav
      aria-label='Main Navigation'
      theme={mode}
      open={isOpened}
      onClose={onToggleMenu}
      drawerProps={{ anchor: 'right' }}
    >
      <SideNavSection>
        {getMenuItems().map(
          ({ path, label, display }) =>
            display && (
              <SideNavItem
                key={path}
                selected={getFirstTwoSegments(pathname) === path}
                onSelected={() => {
                  onToggleMenu()
                  navigate(path)
                }}
              >
                {label}
              </SideNavItem>
            ),
        )}
      </SideNavSection>
    </SideNav>
  )
}

export default NavBar
